export default "__VITE_ASSET__0SbdufqO__"